import React, { Component } from "react";
import { About, Footer, Header, Skills, Work } from "./container";
import { Navbar, ContactBtn, PreLoader } from "./components/";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import "./App.scss";

class App extends Component {
  constructor(props) {
    super(props);

    this.componentRef = React.createRef();
  }

  componentDidMount() {
    const scrollContainer = document.querySelector("#scroll-container");

    gsap.registerPlugin(ScrollTrigger);

    const triggerElement = document.querySelector("#footer");
    const hideElement = document.querySelector("#contactBtn");

    ScrollTrigger.create({
      trigger: triggerElement,
      start: "top 100%",
      onEnter: () => {
        gsap.to(hideElement, { opacity: 0, duration: 0.1 });
      },
      onLeaveBack: () => {
        gsap.to(hideElement, { opacity: 1, duration: 0.1 });
      },
    });

    window.addEventListener("load", this.handlePathChange);
    window.addEventListener("popstate", this.handlePathChange);
  }

  componentWillUnmount() {
    // Remove listener when the component is unmounted
    window.removeEventListener("load", this.handlePathChange);
    window.removeEventListener("popstate", this.handlePathChange);
  }

  handlePathChange = () => {
    const { pathname } = window.location;

    if (pathname === "/login") {
      window.location.href = "https://www.sanity.io/login";
    }
  };

  render() {
    return (
      <div
        className="app"
      >
        <PreLoader />
        <Navbar />
        <Header />
        <About />
        <Work />
        <Skills />
        <Footer />
        <ContactBtn
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        />
      </div>
    );
  }
}

export default App;
